<template>
  <section id="detail_article" class="artikel_view_area pt-100 pb-100">
    <div class="container mt-5">
      <!-- START HEADER -->
      <div class="row justify-content-left">
        <div class="col-lg-6">
          <div class="section_title text-left pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              <span style="border-top: 5px solid black"> Aturan </span>
            </h4>
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              TJSL KAI
            </h4>
            <span
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              <p style="color: black">Aturan TJSL</p>
            </span>
          </div>
        </div>
      </div>
      <!-- END HEADER -->
      <br />
      <!-- START CONTENT -->
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-12">
              <h4
                class="title wow fadeInUp"
                data-wow-duration="1.3s"
                data-wow-delay="0.2s"
              >
                {{ detailAturan.judul }}
              </h4>
            </div>

            <div class="col-lg-12 mt-3">
              <div class="label_artikel_title col-sm-12">
                <p style="font-size: 0.6rem">&nbsp; &nbsp; &nbsp; &nbsp;</p>
              </div>
            </div>

            <div class="col-lg-12">
              <!-- <iframe width="100%" height="500px" :src="detailAturan.file_source + '#view=fit&toolbar=1&navpanes=0'"></iframe> -->
              <iframe width="100%" height="500px" :src="detailAturan.file_source "></iframe>
            </div>
            <!-- <div class="col-lg-12">
              <object width="100%" height="500" type="application/pdf" :data="detailAturan.file_source">
              <p>File Not Found.</p>
              </object>
            </div> -->
            <!-- <div class="col-lg-12">
              <embed
                :src="
                  'https://drive.google.com/viewerng/viewer?embedded=true&url=' +
                  detailAturan.file_source
                "
                width="100%"
                height="500"
              />
            </div> -->
            <!-- <div class="col-lg-12">
              <object
                :data="detailAturan.file_source"
                width="100%"
                height="100%"
              ></object>
            </div> -->
          </div>
        </div>

        <div class="col-lg-4"></div>
      </div>
      <!-- END CONTENT -->
    </div>
  </section>
</template>
<script>
import AturanDataService from "../services/AturanDataService";
export default {
  name: "aturanDetail",
  data() {
    return {
      id: "",
      pageCount: 0, //initial page pagination
      dataPerPage: 3, //for limiting per page
      detailAturan: [],
      aturans: [],
      page: 1,
    };
  },
  components: {},
  methods: {
    retrieveDetailAturans(id) {
      AturanDataService.findById(id)
        .then((response) => {
          this.detailAturan = response.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    getCountAllAturans() {
      AturanDataService.getAll(0, 999999999999999)
        .then((response) => {
          var length = response.data.data.length;
          var divided = length / this.dataPerPage;
          this.pageCount = Math.ceil(divided);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    retrieveAturans(offset, limit) {
      AturanDataService.getAll(offset, limit)
        .then((response) => {
          this.aturans = response.data.data;
          //console.log(this.aturans);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    clickCallback(pageNum) {
      //console.log(pageNum - 1);
      this.retrieveAturans(pageNum - 1, this.dataPerPage);
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.retrieveDetailAturans(this.$route.params.id);
    this.getCountAllAturans();
    this.retrieveAturans(0, this.dataPerPage);
  },
};
</script>

<style>
.label_artikel_title p {
  color: #777777;
  font-size: 8px;
}

.centerBlock {
  display: table;
  margin: auto;
}

.text-overflow-handle {
  white-space: nowrap;
  max-width: 100%;
  height: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
